import React from "react";

const UI = {
  spacing: { xs: 6, sm: 8, md: 12, lg: 16, xl: 24 },
  radius:  { sm: 6, md: 8, lg: 12 },
  colors: {
    primary:   "#0F172A",
    secondary: "#334155",
    muted:     "#64748B",
    subtle:    "#94A3B8",
    border:    "#E2E8F0",
    bg:        "#F8FAFC",
    white:     "#FFFFFF"
  }
};

const JobKpiStrip = ({ jobs, activeKpi, onKpiClick }) => {
  const total = jobs.length;
  
  const stats = {
    all: { count: total, color: "#6366F1", label: "All Jobs" },
    in_progress: { count: jobs.filter(j => j.status === "in_progress").length, color: "#0EA5E9", label: "In Progress" },
    completed: { count: jobs.filter(j => j.status === "completed").length, color: "#059669", label: "Completed" },
    disputed: { count: jobs.filter(j => j.status === "disputed").length, color: "#DC2626", label: "Disputed" },
    pending_payment: { count: jobs.filter(j => j.paymentStatus === "pending").length, color: "#D97706", label: "Pending Payment" },
    cancelled: { count: jobs.filter(j => j.status === "cancelled").length, color: "#64748B", label: "Cancelled" }
  };

  const getPercentage = (count) => total === 0 ? "0%" : `${Math.round((count / total) * 100)}%`;

  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(6, 1fr)",
      gap: UI.spacing.md,
      marginBottom: UI.spacing.xl
    }}>
      {Object.entries(stats).map(([key, stat]) => {
        const isActive = activeKpi === key;
        const percentage = getPercentage(stat.count);
        const trend = stat.count > 0 ? "▲" : "▼";
        const trendColor = stat.count > 0 ? "#10B981" : "#EF4444";
        
        return (
          <div
            key={key}
            onClick={() => onKpiClick(key)}
            style={{
              background: isActive ? stat.color : UI.colors.white,
              border: isActive ? "none" : `1px solid ${stat.color}`,
              borderRadius: UI.radius.lg,
              padding: `${UI.spacing.md}px ${UI.spacing.sm}px`,
              cursor: "pointer",
              transition: "all 0.15s ease",
              textAlign: "center"
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                e.currentTarget.style.transform = "translateY(-2px)";
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.transform = "translateY(0)";
              }
            }}
          >
            <div style={{
              fontSize: 22,
              fontWeight: 800,
              fontFamily: "'Playfair Display', serif",
              color: isActive ? UI.colors.white : stat.color,
              marginBottom: UI.spacing.xs
            }}>
              {stat.count}
            </div>
            <div style={{
              fontSize: 11.5,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 600,
              letterSpacing: "0.05em",
              textTransform: "uppercase",
              color: isActive ? "rgba(255,255,255,0.9)" : UI.colors.muted,
              marginBottom: UI.spacing.xs
            }}>
              {stat.label}
            </div>
            <div style={{
              fontSize: 10,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              color: isActive ? "rgba(255,255,255,0.7)" : UI.colors.subtle,
              marginBottom: 4
            }}>
              {percentage}
            </div>
            <div style={{
              fontSize: 10,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 600,
              color: isActive ? "#FFFFFF" : trendColor
            }}>
              {trend}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default JobKpiStrip;